import { useI18n } from "../i18n/LanguageContext";

export function LanguageToggle() {
  const { lang, setLang } = useI18n();
  return (
    <div className="inline-flex items-center rounded-full bg-ink-50 p-0.5 text-[11px] font-semibold tracking-wide">
      {(["tr", "en"] as const).map((l) => (
        <button
          key={l}
          onClick={() => setLang(l)}
          aria-pressed={lang === l}
          className={
            "px-2.5 py-1 rounded-full transition " +
            (lang === l
              ? "bg-ink-900 text-white shadow-sm"
              : "text-ink-500 hover:text-ink-800")
          }
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
